export const shouldHandleUnauthorized = (error, currentToken) => {
  if (!currentToken) return true;
  const headers = error.config?.headers;
  const authorization = headers?.get?.('Authorization') ?? headers?.Authorization ?? headers?.authorization;
  return authorization === `Bearer ${currentToken}`;
};
